export const FONT_CONSTANTS = {
    fonts: ['Inter', 'Noto Sans', 'Recursive', 'Inconsolata', 'Zilla Slab'],
};
